import { RiNewspaperLine } from '@remixicon/react'
import { Perm_MenuReport_View, Perm_Order_Report_Kt, Perm_ProfitReport_View } from '../../app/hooks/premissionScreen'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiNewspaperLine
}

export const reportMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'list-report',
    title: 'Báo cáo',
    icon: icons.RiNewspaperLine,
    iconActive: icons.RiNewspaperLine,
    premissions: Perm_MenuReport_View,
    children: [
      createItem({
        id: 'report-kt',
        title: 'Báo cáo kết toán',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.REPORT_KT}`,
        premissions: Perm_Order_Report_Kt
      }),
      createItem({
        id: 'report-checklist',
        title: 'Bảng kê',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.REPORT_CHECK_LIST}`,
        premissions: Perm_Order_Report_Kt
      }),
      createItem({
        id: 'report-profit',
        title: 'Báo cáo lợi nhuận',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.PROFIT_REPORT}`,
        premissions: Perm_ProfitReport_View
      }),
      createItem({
        id: 'business-analytics',
        title: 'Phân tích hiệu quả',
        url: `/${ROUTES.REPORT}/${ROUTES.REPORT_CHILD.ANALYTICS}`,
        premissions: Perm_ProfitReport_View
      })
    ]
  })
]
